<template>
  <!-- Add Customer -->
  <div class="modal fade" id="add-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Ajouter un nouveau Bon de livraison</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <!-- <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Numéro du Bon</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form.numero_bon"
                        required
                      />
                    </div>
                  </div> -->
                  <div class="col-lg-6 col-md-6 col-12">
                    <div class="mb-3">
                      <label class="form-label">Facture</label>
                      <vue-select
                        v-model="selectedFacture"
                        :options="factures"
                        :settings="factureSelectSettings"
                        id="bon-livraison-facture"
                        placeholder="Rechercher une facture ou un client"
                      />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-12">
                    <div class="input-blocks">
                      <label>Statut</label>
                      <vue-select v-model="form.statut" :options="Completed" id="progressss" placeholder="Choose"
                        :clearable="false" />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-12">
                    <label class="form-label">Date de livraison</label>
                    <div class="position-relative">
                      <vue-feather type="calendar" class="position-absolute"
                        style="left:12px; top:50%; transform:translateY(-50%); z-index:2; pointer-events: none;" />

                      <input type="datetime-local" v-model="form.date_livraison" class="form-control w-100 ps-5" />
                    </div>
                  </div>
                  <div class="col-lg-6 col-md-6 col-12">
                    <div class="mb-3">
                      <label class="form-label">Transporteur</label>
                      <input type="text" class="form-control" v-model="form.transporteur" required />
                    </div>
                  </div>
                  <div class="col-lg-12 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Adresse de livraison</label>
                      <textarea class="form-control form-control-lg group_formcontrol" type="text"
                        v-model="form.adresse_livraison" required></textarea>
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom du recepteur</label>
                      <input type="text" class="form-control" v-model="form.nom_recepteur" required />
                    </div>
                  </div>
                  <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Numéro de téléphone</label>
                      <input type="text" class="form-control" v-model="form.telephone_recepteur" required />
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-12">
                    <div class="mb-3">
                      <label class="form-label">Livreur</label>
                      <vue-select v-model="selectedLivreur" :options="usersData" id="progresssdfas"
                        placeholder="Choose" />
                    </div>
                  </div>



                  <div class="col-lg-12">
                    <div class="mb-3 input-blocks">
                      <label class="form-label">Informations Complementaires</label>
                      <textarea class="form-control mb-1" v-model="form.notes_livraison"></textarea>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Add Customer -->

  <!-- Edit Customer -->
  <div class="modal fade" id="edit-units">
    <div class="modal-dialog add-centered">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header justify-content-between">
              <div class="page-title">
                <h4>Modifier un Bon de livraison</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm1">
                <div class="row">
                  <!-- <div class="col-lg-4 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Numéro du Bon</label>
                      <input
                        type="text"
                        class="form-control"
                        v-model="form1.numero_bon"
                        required
                      />
                    </div>
                  </div> -->

                  <div class="col-lg-6 col-md-6 col-12">
                    <label class="form-label">Date de livraison</label>
                    <div class="position-relative">
                      <vue-feather type="calendar" class="position-absolute"
                        style="left:12px; top:50%; transform:translateY(-50%); z-index:2; pointer-events: none;" />

                      <input type="datetime-local" v-model="form1.date_livraison" class="form-control w-100 ps-5" />
                    </div>
                  </div>

                  <div class="col-lg-6 col-sm-6 col-12">
                    <div class="input-blocks">
                      <label>Statut</label>
                      <vue-select v-model="form1.statut" :options="Completed" id="progresssss" placeholder="Choose" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Livreur</label>
                      <vue-select v-model="selectedLivreur" :options="usersData" id="progresssdfassds"
                        placeholder="Choose" />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Transporteur</label>
                      <input type="text" class="form-control" v-model="form1.transporteur" required />
                    </div>
                  </div>
                  
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Nom du recepteur</label>
                      <input type="text" class="form-control" v-model="form1.nom_recepteur" required />
                    </div>
                  </div>
                  <div class="col-lg-6 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Numéro de téléphone</label>
                      <input type="text" class="form-control" v-model="form1.telephone_recepteur" required />
                    </div>
                  </div>
                  <div class="col-lg-12 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Adresse de livraison</label>
                      <textarea class="form-control form-control-lg group_formcontrol" type="text"
                        v-model="form1.adresse_livraison" required></textarea>
                    </div>
                  </div>
                  

                  <div class="col-lg-12 pe-0">
                    <div class="mb-3">
                      <label class="form-label">Facture</label>
                      <input type="text" class="form-control" :value="selectedFacture" disabled />
                      <small class="text-muted">Non modifiable</small>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="mb-3 input-blocks">
                      <label class="form-label">Informations Complementaires</label>
                      <textarea class="form-control mb-1" v-model="form1.notes_livraison" ></textarea>
                      <p>Maximum 60 Characters</p>
                    </div>
                  </div>
                </div>

                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Annuler
                  </button>
                  <button type="submit" class="btn btn-submit">
                    Confirmer
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <!-- /Edit Customer -->
</template>
<script>
import { Modal } from "bootstrap";
import { decodeToken } from "@/services/jwtService";
import { toast } from "vue3-toastify";
import { getFacturesData } from "@/services/facturesService";
import { getUsers as getUsersData } from "@/services/userService";
import {
  createBonLivraison,
  updateBonLivraison,
} from "@/services/deliveryService";

const factures = [];
const facturesID = [];
const usersData = [];
const userIds = [];
export default {
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({}),
    },
  },
  data() {
    return {
      form: {
        numero_bon: "",
        date_creation: new Date(),
        date_livraison: "",
        statut: "EN_ATTENTE",
        transporteur: "",
        adresse_livraison: "",
        notes_livraison: "",
        nom_recepteur: "",
        telephone_recepteur: "",
        signature_client: "",
        facture_id: null,
        livreur_id: null,
        numero_suivi: null,
        societe_id: null,
      },
      form1: {
        id: null,
        numero_bon: "",
        date_livraison: null,
        statut: "Maroc",
        transporteur: "",
        adresse_livraison: "",
        notes_livraison: "",
        nom_recepteur: "",
        telephone_recepteur: "",
        signature_client: "",
        facture_id: null,
        livreur_id: null,
        numero_suivi: null,
        societe_id: null,
      },

      ClientsType: ["FOURNISSEUR", "CLIENT", "PROSPECT"],
      // Keep backend codes in `id`, show French labels in `text`
      Completed: [
        { id: "LIVRÉ", text: "Livré" },
        { id: "ANNULÉ", text: "Annulé" },
        { id: "EN_ATTENTE", text: "En attente" },
        { id: "RETOURNÉ", text: "Retourné" },
        { id: "EN_COURS", text: "En cours" },
      ],
      Types: ["INDIVIDUAL", "COMPANY"],
      Civilite: ["M", "MME"],
      ChooseCusOne: ["Varrel", "Varrel"],
      ChooseCityOne: ["Germany", "United State"],
      dateFormat: "dd-MM-yyyy",
      factures,
      facturesID,
      usersData,
      userIds,
      selectedFacture: null,
      selectedLivreur: null,
      factureSelectSettings: {
        dropdownParent: "#add-units",
        minimumResultsForSearch: 0,
        width: "100%",
      },
    };
  },
  methods: {

    getFactureClientName(facture) {
      const client = facture?.commande?.client || facture?.client || {};
      const companyName = facture?.client_nom_societe || client?.nom_societe;
      if (companyName) return String(companyName).trim();

      const directName = facture?.client_name || facture?.client_nom || facture?.commande?.nom_client;
      if (directName) return String(directName).trim();

      return [client?.prenom, client?.nom]
        .filter(Boolean)
        .join(" ")
        .trim();
    },

    async getFacturesData() {
      this.factures = [];
      this.facturesID = [];
      try {
        const data = await getFacturesData();

        data.map((m) => {
          const clientName = this.getFactureClientName(m);
          const factureLabel = clientName
            ? `${m.numero_facture} — ${clientName}`
            : m.numero_facture;
          this.factures.push(factureLabel);
          this.facturesID.push(m.id);
        });
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
      }
    },
    async submitForm() {
      let user = decodeToken(localStorage.getItem("access_token"));
      this.form.societe_id = user.societe_id;
      this.form.facture_id = this.getFactureID(this.selectedFacture);
      this.form.livreur_id = this.getUserID(this.selectedLivreur);

      // Convert datetime-local format to backend format
      let dateLivraisonFormatted = null;
      if (this.form.date_livraison) {
        dateLivraisonFormatted = this.form.date_livraison.replace('T', ' ') + ':00';
      }

      try {
        const response = await createBonLivraison({
          date_creation: new Date().toISOString().slice(0, 19).replace("T", " "),
          date_livraison: dateLivraisonFormatted,
          statut: this.form.statut,
          transporteur: this.form.transporteur,
          adresse_livraison: this.form.adresse_livraison,
          notes_livraison: this.form.notes_livraison,
          nom_recepteur: this.form.nom_recepteur,
          telephone_recepteur: this.form.telephone_recepteur,
          signature_client: this.form.signature_client,
          facture_id: this.form.facture_id,
          livreur_id: this.form.livreur_id,
          numero_suivi: this.form.numero_suivi,
          societe_id: this.form.societe_id,
        });
        this.$emit("bon-added", response);
        const modalElement = document.getElementById("add-units");
        const modal = Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        const message = error?.response?.data?.message || "Erreur lors de l'envoi du bon";
        toast.error(message);
      }
    },
    async submitForm1() {
      try {
        const response = await updateBonLivraison(this.form1.id, {

          date_livraison: this.form1.date_livraison,

          statut: this.form1.statut,
          transporteur: this.form1.transporteur,
          adresse_livraison: this.form1.adresse_livraison,
          notes_livraison: this.form1.notes_livraison,
          nom_recepteur: this.form1.nom_recepteur,
          telephone_recepteur: this.form1.telephone_recepteur,
          signature_client: this.form1.signature_client,
          livreur_id: this.form1.livreur_id,
          numero_suivi: this.form1.numero_suivi,
          societe_id: this.form1.societe_id,
        });
        this.$emit("bon-updated", response);

        const modalElement = document.getElementById("edit-units");
        const modal =
          Modal.getInstance(modalElement) || new Modal(modalElement);
        modal.hide();
      } catch (error) {
        console.error(error);
        const message =
          error?.response?.data?.message || "Erreur lors de l'envoi du bon";
        toast.error(message);
      }
    },
    async getUsersData() {
      this.usersData = [];
      this.userIds = [];
      try {
        const data = await getUsersData();
        data.map((m) => {
          this.usersData.push(m.name);
          this.userIds.push(m.id);
        });
      } catch (error) {
        console.error(error);
        toast.error(error.response.data.message);
      }
      //console.log(usersData);
    },
    getUserID(option) {
      let index = this.usersData.indexOf(option);
      if (index != -1) {
        return this.userIds[index];
      }
      return index;
    },
    getFactureID(option) {
      let index = this.factures.indexOf(option);
      if (index != -1) {
        return this.facturesID[index];
      }
      // Not found
      return null;
    },
    openAddModal() {
      const now = new Date();
      const year = now.getFullYear();
      const month = String(now.getMonth() + 1).padStart(2, '0');
      const day = String(now.getDate()).padStart(2, '0');
      const hours = String(now.getHours()).padStart(2, '0');
      const minutes = String(now.getMinutes()).padStart(2, '0');
      this.form.date_livraison = `${year}-${month}-${day}T${hours}:${minutes}`;

      const modal = new Modal(document.getElementById("add-units"));
      modal.show();
    },
    getUserName(userId) {
      if (!this.userIds || !this.usersData) return null;

      const index = this.userIds.indexOf(userId);
      return index !== -1 ? this.usersData[index] : null;
    },
    getFactureName(option) {
      let index = this.facturesID.indexOf(option);
      if (index != -1) {
        return this.factures[index];
      }
      // Not found
      return "";
    },
    parseFormattedDate(formattedStr) {
      try {
        // Parse string like "17 août 2025"
        const d = new Date(formattedStr);
        if (isNaN(d)) return null;

        // Return backend format "YYYY-MM-DD HH:mm:ss"
        const year = d.getFullYear();
        const month = String(d.getMonth() + 1).padStart(2, "0");
        const day = String(d.getDate()).padStart(2, "0");
        const hours = String(d.getHours()).padStart(2, "0");
        const minutes = String(d.getMinutes()).padStart(2, "0");
        const seconds = String(d.getSeconds()).padStart(2, "0");

        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
      } catch (e) {
        console.error("Erreur lors de la conversion :", e);
        return null;
      }
    },
  },
  watch: {
    data: {
      immediate: true,
      handler(newData) {
        this.form1.id = newData.id;
        this.form1.numero_bon = newData?.numero_bon || "";
        this.form1.date_creation = new Date(newData?.date_creation) || "";
        if (newData?.date_livraison) {
          const d = new Date(newData.date_livraison);
          this.form1.date_livraison =
            `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
        }

        this.form1.statut = newData?.statut || "";
        this.form1.transporteur = newData?.transporteur || "";
        this.form1.adresse_livraison = newData?.adresse_livraison || "";
        this.form1.notes_livraison = newData?.notes_livraison || "";
        this.form1.nom_recepteur = newData?.nom_recepteur || "";
        this.form1.telephone_recepteur = newData?.telephone_recepteur || "";
        this.form1.signature_client = newData?.signature_client || "";
        this.form1.facture_id = newData?.facture_id || "";
        this.form1.livreur_id = newData?.livreur_id || "";
        this.form1.numero_suivi = newData?.numero_suivi || "";
        this.form1.societe_id = newData?.societe_id || "";
        // Prefer mapping via loaded factures list; fallback to nested facture numero
        const mappedRef = this.getFactureName(this.form1.facture_id);
        this.selectedFacture = mappedRef || (newData?.facture?.numero_facture || "");
        this.selectedLivreur = this.getUserName(this.form1.livreur_id);
      },
    },
    // When factures list loads/changes, re-evaluate displayed facture ref
    facturesID() {
      if (this.form1.facture_id) {
        const mappedRef = this.getFactureName(this.form1.facture_id);
        if (mappedRef) this.selectedFacture = mappedRef;
      }
    }
  },
  mounted() {
    this.getFacturesData();
    this.getUsersData();
    // Set default datetime to now in local format
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    const hours = String(now.getHours()).padStart(2, '0');
    const minutes = String(now.getMinutes()).padStart(2, '0');
    this.form.date_livraison = `${year}-${month}-${day}T${hours}:${minutes}`;
  },
};
</script>
